'use client';

import type { FC } from 'react';
import Image from 'next/image';

import type { Allergen } from '@hyex/dxp/types/store/Product/Allergen';

type PropTypes = {
  allergens: Allergen[];
  className?: string;
  table?: boolean;
  productName: string;
};

// - allergens Web Title like  (above <label>)

const ProductAllergens: FC<PropTypes> = ({ allergens = [], className = '', productName }) => {
  const icon = (allergen: Allergen) => {
    const hasIcon = allergen && !!allergen.icon;

    const hasNotes = allergen && !!allergen.notes;

    if (hasIcon)
      return (
        <>
          <Image
            className="icon-image"
            alt={`Allergen ${allergen.webTitle} in ${productName}`}
            src={allergen?.icon ?? ''}
            width={24}
            height={24}
            quality="70"
            key={allergen.allergen}
          />
          <label>{allergen.webTitle}</label>
        </>
      );

    if (hasNotes) return <span className={allergen.allergen}>{allergen.notes}</span>;

    return <></>;
  };

  return (
    <div className={`${className} product-icons-list`}>
      {allergens
        .filter((d) => !d.hidden)
        .filter((d) => d.exists)
        .map((allergen, i) => (
          <div className="product-icon" key={i}>
            {icon(allergen)}
          </div>
        ))}
    </div>
  );
};

export default ProductAllergens;
